import React from "react";
import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";

import { lang } from "../../../middleware/lang";
import {
  CREATE_CONNECT_ACCOUNT,
  CreateConnectAccountResponse,
} from "./queries";

type Props = {
  onComplete: () => void;
};

const ConnectSetup: React.FC<Props> = ({ onComplete }) => {
  const [createAccount, { loading }] = useMutation<CreateConnectAccountResponse>(
    CREATE_CONNECT_ACCOUNT
  );

  const handleConnect = async () => {
    try {
      const { data } = await createAccount();
      if (data?.createConnectAccount.url) {
        window.location.href = data.createConnectAccount.url;
      }
    } catch (e: any) {
      toast.error(e.message || "Error al conectar cuenta");
    }
  };

  return (
    <div className="container" style={{ maxWidth: 600, marginTop: "3rem" }}>
      <div
        style={{
          background: "#fff",
          border: "1px solid #ebebeb",
          borderRadius: 12,
          padding: "2.5rem 2rem",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            background: "#FFBB28",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 1.5rem",
          }}
        >
          <i className="fas fa-university" style={{ fontSize: 28, color: "#292929" }} />
        </div>

        <h3 style={{ fontWeight: 700, marginBottom: "0.75rem" }}>
          {lang("Recibe pagos en linea", "Receive online payments")}
        </h3>

        <p style={{ color: "#666", maxWidth: 420, margin: "0 auto 1.5rem" }}>
          {lang(
            "Conecta tu cuenta bancaria para recibir automaticamente los pagos de tus clientes que pagan con tarjeta a traves de la app.",
            "Connect your bank account to automatically receive payments from customers who pay with card through the app."
          )}
        </p>

        <div
          style={{
            background: "#f8f9fa",
            borderRadius: 8,
            padding: "1rem",
            marginBottom: "1.5rem",
            textAlign: "left",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
            <i className="fas fa-check-circle" style={{ color: "#48BB78" }} />
            <span>{lang("Configuracion rapida y segura", "Quick and secure setup")}</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
            <i className="fas fa-check-circle" style={{ color: "#48BB78" }} />
            <span>{lang("Depositos automaticos a tu banco", "Automatic deposits to your bank")}</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <i className="fas fa-check-circle" style={{ color: "#48BB78" }} />
            <span>
              {lang(
                "Panel de seguimiento de pagos y depositos",
                "Payments and deposits tracking dashboard"
              )}
            </span>
          </div>
        </div>

        <button
          className="btn btn-lg"
          style={{
            background: "#FFBB28",
            color: "#292929",
            fontWeight: 700,
            borderRadius: 8,
            padding: "0.75rem 2rem",
          }}
          onClick={handleConnect}
          disabled={loading}
        >
          {loading ? (
            <span className="spinner-border spinner-border-sm mr-2" />
          ) : (
            <i className="fas fa-link mr-2" />
          )}
          {lang("Conectar cuenta bancaria", "Connect bank account")}
        </button>

        <p style={{ color: "#999", fontSize: 12, marginTop: "1rem" }}>
          {lang(
            "Seras redirigido a Stripe para completar la verificacion.",
            "You'll be redirected to Stripe to complete verification."
          )}
        </p>
      </div>
    </div>
  );
};

export default ConnectSetup;
